import { Education, IFeature, PaymentMessageFeature, RecaptchaConfig, Ref } from '.';

export interface feature {
    additionalTradingAccount?: IFeature;
    calculatorTools?: IFeature;
    contest?: IFeature;
    education?: Education;
    recaptcha?: RecaptchaConfig;
    registerPartner?: IFeature;
    referAFriend?: Ref;
    scbLeverage?: {
        enabled: boolean;
        threshold: number;
    };
    signup?: { cysecPercentage: string };
    tradingViewTools?: IFeature;
    upgradeToPro?: IFeature & { mentorEducationLink: string; allowTenants: string[] };

    payment?: {
        checkActiveGatewayPlatforms: string[];
    };
    paymentMessages?: PaymentMessageFeature;
}
